module.exports = __webpack_public_path__ + "img/cup.be45f802.svg";